import { get, put, post } from 'services/api-client';

const surveyService = {
  get: (id) => get(`/survey?id=${id}`),

  getByReportId: (reportId) => get(`/survey/report/${reportId}`),

  update: (data, regenerateReport) => put(`/survey/update?regenerateReport=${regenerateReport}`, data),

  charge: (surveyId, data) => post(`/survey/${surveyId}/charge`, data)
}

export default surveyService;